import { LoyaltyService } from './loyalty.service';
import { MappingService } from './mapping.service';

export const services = [LoyaltyService, MappingService];

export * from './loyalty.service';
export * from './mapping.service';
